import { AxiosError } from 'axios';
import { ReportVersion } from 'types/ModelTypes';

export type ReportVersionHistoryError =
    | 'unauthorized'
    | 'unavailable'
    | 'missing'
    | 'unsupported'
    | 'failed';

export const getReportVersionHistoryError = (error: unknown): ReportVersionHistoryError => {
    const status = (error as AxiosError)?.response?.status;

    if (status === 401 || status === 403) return 'unauthorized';
    if (status === 404) return 'missing';
    if (status === 501) return 'unsupported';
    if (status === 503) return 'unavailable';

    return 'failed';
};

export const sortReportVersionsNewestFirst = (versions: ReportVersion[]) =>
    [...versions].sort((first, second) => {
        const dateDifference = new Date(second.generatedUtc).getTime() - new Date(first.generatedUtc).getTime();
        return dateDifference !== 0 ? dateDifference : second.version - first.version;
    });

export const getReportVersionHistoryErrorMessage = (error: ReportVersionHistoryError) => {
    switch (error) {
        case 'unauthorized':
            return 'You are not authorized to view this report history.';
        case 'missing':
            return 'Report history is unavailable because the report version could not be found.';
        case 'unsupported':
            return 'Report version history is not available until the reporting service is upgraded.';
        case 'unavailable':
            return 'Report history is temporarily unavailable. Please try again later.';
        default:
            return 'Report history could not be loaded. Please try again.';
    }
};

export const getReportVersionDownloadErrorMessage = (error: ReportVersionHistoryError) => {
    switch (error) {
        case 'unauthorized':
            return 'You are not authorized to download this report version.';
        case 'missing':
            return 'This report version is unavailable because its file could not be found.';
        case 'unsupported':
            return 'Report version downloads are not available until the reporting service is upgraded.';
        case 'unavailable':
            return 'Report download is temporarily unavailable. Please try again later.';
        default:
            return 'The report version could not be downloaded. Please try again.';
    }
};
